import * as React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import productDataActions from './product-data-actions'


/*

The forms have a variety of "constants" that must be pulled from the server. They relate to:

    - product and other options for dropdown selections
    - excesses values
    - sums insured values

There are 4 endpoints that must be supplied in the configuation of this module, that pull this data.
The data from the server is mapped to a structure that better suits the clientside needs before being
saved to the state.productData state.

There are two decorators that can be used to wrap form pages:

- @withProductData: This ensures that the product data is loaded and cached before the form page is
                    displayed. On step-1, a token hasn't yet been generated, which is nessessary for
                    the endooints to be called. Therefore we don't want this decorator on step-1
                    
- @withProductDataDefered: Expose only the requestProductData() action. We can call requestProductData()
                           after a successful submission response on step-1, to pre-cache the product data
                           before moving on to step-2. This isn't completely nessessary, but it helps to 
                           avoid flashing page states in the transition between step-1 and step-2

*/


function mapStateToProps(state, intialProps){
    return {
        ...intialProps,
        productData: state.productData
    }
}


function mapDispatchToProps(dispatch, props){
    return {
        actions:{
            ...props.actions,
            productData: bindActionCreators(productDataActions, dispatch)
        }
    }
}



export const withProductDataDefered = (Wrapped:React.ComponentClass) => connect(mapStateToProps, mapDispatchToProps)(Wrapped)


export const withProductData = (Wrapped:React.ComponentClass) => {

    return connect(mapStateToProps, mapDispatchToProps)(class extends React.Component<any, any>{


        componentDidMount(){
            const loaded = this.props.productData.loaded;
            if(!loaded){
                this.props.actions.productData.requestProductData();
            }
        }


        render(){
            const loaded = this.props.productData.loaded;

            if(!loaded) return null;
            return <Wrapped { ...this.props } />
        }

    })

}




// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/common/modules/product-data/index.tsx